import { diffCalendarDaysYmd } from '../utils/taskEarlySubmit';

/** Tailwind badge classes by calendar days until expiry (today → expiry date). */
export const inventoryV2ExpiryBadgeToneClassName = (daysUntil: number): string => {
  if (daysUntil < 0) {
    return 'border-neutral-900 bg-neutral-950 text-white dark:border-neutral-800 dark:bg-black dark:text-white';
  }
  if (daysUntil <= 7) {
    return 'border-red-200 bg-red-50 text-red-800 dark:border-red-900 dark:bg-red-950/55 dark:text-red-100';
  }
  if (daysUntil <= 14) {
    return 'border-amber-200 bg-amber-50 text-amber-950 dark:border-amber-800 dark:bg-amber-950/50 dark:text-amber-100';
  }
  if (daysUntil <= 29) {
    return 'border-blue-200 bg-blue-50 text-blue-900 dark:border-blue-800 dark:bg-blue-950/50 dark:text-blue-100';
  }
  return 'border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-800 dark:bg-emerald-950/45 dark:text-emerald-100';
};

type InventoryV2ExpiryTranslator = (key: string, params?: Record<string, string | number>) => string;

export const resolveInventoryV2ExpiryBadge = (
  t: InventoryV2ExpiryTranslator,
  todayYmd: string,
  expiryYmd: string,
): { label: string; badgeClassName: string } => {
  const daysUntil = diffCalendarDaysYmd(todayYmd, expiryYmd);
  const badgeClassName = inventoryV2ExpiryBadgeToneClassName(daysUntil);
  if (daysUntil < 0) {
    return { label: t('task.review.inventoryExpiryExpired'), badgeClassName };
  }
  if (daysUntil >= 30) {
    return {
      label: t('task.review.inventoryExpiryAbsolute', { date: expiryYmd }),
      badgeClassName,
    };
  }
  if (daysUntil === 0) {
    return { label: t('task.review.inventoryExpiryToday'), badgeClassName };
  }
  if (daysUntil === 1) {
    return { label: t('task.review.inventoryExpiryTomorrow'), badgeClassName };
  }
  return {
    label: t('task.review.inventoryExpiryInDays', { count: daysUntil }),
    badgeClassName,
  };
};
